import React, {Component} from 'react'
import {Entity} from 'aframe-react'

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {setCameraRotation} from '../actions/camera'
// import cam from '../helpers/camera-helper'

import aframe from "aframe"

import extras from "aframe-extras"
extras.controls.registerAll()

class Camera extends Component {
    render() {
        return (
            <Entity
                primitive="a-camera"
                id="camera"

                universal-controls={{
                    movementEnabled: false,
                    rotationControls: ['hdm', 'mouse'],
                }}

                wasd-controls-enabled={false}

                fov={this.props.fov}

                events={{
                    componentchanged: (e) => {
                        if (e.detail.name !== 'rotation')
                            return
                        
                        //cam.setRot(e.detail.newData.x, e.detail.newData.y)

                        /*this.props.setCameraRotation(
                            e.detail.newData.x,
                            e.detail.newData.y
                        )*/
                    }
                }}
            >
                <Entity 
                    primitive="a-cursor" 
                    id="main-cursor" 

                    geometry={{
                        primitive: "ring",
                        //radiusOuter: 0.016,
                        //radiusInner: 0.01,

                        radiusOuter: 0.01,
                        radiusInner: 0.001,

                        //radiusOuter: 0.026,
                        //radiusInner: 0.02,
                    }}

                    material={{
                        transparent: true,
                        color: "#000"
                    }}

                    scale={{
                        x: 0.4, y: 0.4, z: 1,
                    }}

                    cursor="fuse: false" 
                >
                     <a-animation

                        attribute="geometry.radiusInner"

                        from="0.001" 
                        to="0.02"

                        dur="200"

                        begin="cursorEnter"
                        end="cursorLeave"
                    />
                    <a-animation

                        attribute="geometry.radiusInner"

                        from="0.02"
                        to="0.001" 

                        dur="200"

                        begin="cursorLeave"
                        end="cursorEnter"
                    />


                    <a-animation

                        attribute="geometry.radiusOuter"

                        from="0.01" 
                        to="0.026"

                        dur="200"

                        begin="cursorEnter"
                        end="cursorLeave"
                    />
                    <a-animation

                        attribute="geometry.radiusOuter"

                        to="0.01" 
                        from="0.026"


                        dur="200"

                        begin="cursorLeave"
                        end="cursorEnter"
                    />

                </Entity>
            </Entity>
        );
    }
}

const userAgent = navigator.userAgent || navigator.vendor

const mapStateToProps = (state) => {
    return {
        fov: (/android/i.test(userAgent)) ? "90" : "60",
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setCameraRotation: setCameraRotation
    }, dispatch);

}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(Camera)



// WEBPACK FOOTER //
// ./src/components/camera.js